module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-42.9e499bdf.svg";